import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../lib/i18n";

export const ANALYTICS_CONSENT_KEY = "argali_analytics_consent";
export const CONSENT_EVENT = "argali-consent-changed";
export const OPEN_CONSENT_EVENT = "argali-open-cookie-settings";

export default function CookieConsent() {
  const { lang } = useLang();
  const [open, setOpen] = useState(() => !localStorage.getItem(ANALYTICS_CONSENT_KEY));

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_CONSENT_EVENT, show);
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, show);
  }, []);

  const choose = (value) => {
    localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
    window.dispatchEvent(new Event(CONSENT_EVENT));
    setOpen(false);
  };

  if (!open) return null;
  return (
    <aside className="fixed bottom-0 left-0 right-0 z-[100] border-t border-argali-sandstone/20 bg-[#11110F] text-argali-ivory shadow-2xl" role="dialog" aria-label={lang === "ru" ? "Настройки cookie" : "Cookie settings"}>
      <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-5 flex flex-col md:flex-row md:items-center gap-5">
        <p className="text-sm leading-relaxed flex-1">
          {lang === "ru" ? "Мы используем необходимые cookie для работы сайта. Яндекс Метрика и Вебвизор включатся только с вашего согласия." : "We use necessary cookies to operate the site. Yandex Metrica and Webvisor will run only with your consent."}{" "}
          <Link to="/privacy" className="underline text-argali-gold">{lang === "ru" ? "Подробнее" : "Learn more"}</Link>
        </p>
        <div className="flex flex-wrap gap-3">
          <button type="button" onClick={() => choose("declined")} className="btn-outline">{lang === "ru" ? "Только необходимые" : "Necessary only"}</button>
          <button type="button" onClick={() => choose("accepted")} className="btn-bronze">{lang === "ru" ? "Разрешить аналитику" : "Allow analytics"}</button>
        </div>
      </div>
    </aside>
  );
}
